<template>
  <div class="login_bg">
    <div class="form_container" v-loading="formLoading">
      <div class="logo_col">
        <img :src="g_imgSrc.logo" alt="" />
      </div>
      <div class="system_title">腾讯智慧医药管理平台</div>
      <el-form
        v-if="loginType === 1 || afterOkta"
        ref="ruleForm"
        :model="form"
        class="form_box"
        :rules="rules"
      >
        <el-form-item prop="phone">
          <el-input
            v-model="form.phone"
            :disabled="afterOkta"
            placeholder="请输入您的手机号"
            :maxlength="11"
            type="tel"
          />
        </el-form-item>
        <el-form-item prop="checkCode">
          <div class="checkCode_col" @keyup.enter="userLogin">
            <el-input
              v-model="form.checkCode"
              class="checkCode_input"
              placeholder="请输入验证码"
              :maxlength="6"
              type="text"
            />
            <el-button
              type="primary"
              @click="startCountDown"
              :disabled="!codeBtnStatus"
              class="getCode"
            >
              {{ checkCodeText }}
            </el-button>
          </div>
        </el-form-item>
        <div class="auto_login">
          <el-checkbox v-model="form.autoLogin">
            <span>自动登录</span>
          </el-checkbox>
        </div>
      </el-form>
      <el-button
        class="login_btn"
        :class="{ active: !btnDisabled }"
        :disabled="btnDisabled"
        v-if="loginType === 1"
        @click="userLogin"
      >
        登录
      </el-button>
      <div id="wx_reg" v-if="loginType === 2"></div>
      <div v-if="loginType === 3">
        <el-button
          class="login_btn active"
          v-if="beforeOkta"
          @click="loginByOkta"
          style="margin: 100px 0"
        >
          通过OKTA验证登录
        </el-button>
        <el-button
          class="login_btn"
          :class="{ active: !btnDisabled }"
          v-if="afterOkta"
          @click="phoneLoginByOkta"
          :disabled="btnDisabled"
        >
          登录
        </el-button>
      </div>
      <div class="document_col">
        <span @click="g_tourl('/saas/help.html')">帮助</span>
        <span class="and">&</span>
        <span @click="g_tourl('/saas/protocol.html')">条款</span>
      </div>
      <div class="produced_col">copyright© 2021腾讯科技（深圳）有限公司出品</div>
    </div>
  </div>
</template>
<script>
import { PHONE_REG } from '@/utils/constant';
import { SendSmsCode } from '@/api/login.js';
import login from '@/utils/login.js';
import { loadJs, gotoHome, getUrlDomain } from '@/utils/util';
import { lstore, query } from '@/libs/utils/util';
import config from '@/config';

const totolTime = 60;
const wwloginConfig = {
  id: 'wx_reg', // 企业页面显示二维码的DOM id
  appid: 'wwf48366fdd583429b', // 企业微信的CorpID，在企业微信管理端查看
  agentid: '1000052', // 授权方的网页应用ID，在具体的网页应用中查看
  redirect_uri: '', // 重定向地址，需要进行UrlEncode
  href: 'https://baike-med-1256891581.file.myqcloud.com/saas/production/common/workWxQrCode.css',
};
wwloginConfig.redirect_uri = `${document.location.protocol}//${document.location.host}/saas/login/door.html`;
if (query('redirect_uri')) {
  wwloginConfig.redirect_uri += `?redirect_uri=${btoa(encodeURIComponent(query('redirect_uri')))}`;
  wwloginConfig.redirect_uri = encodeURI(wwloginConfig.redirect_uri);
}
let LoginConfig = {};
export default {
  data() {
    const validatorPhone = (rule, value, callback) => {
      if (!PHONE_REG.test(value)) {
        callback(new Error('手机号格式不正确'));
        return;
      }
      callback();
    };
    return {
      // 表单
      form: {
        autoLogin: true,
        checkCode: null,
        phone: null,
      },
      rules: {
        phone: [{ validator: validatorPhone, trigger: 'blur' }],
        checkCode: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      loginType: 1, // 登录方式，1手机号，2企微扫码，3Okta登录
      loginReadyOkta: false, // 是否已经通过okta验证完毕
      // 状态管理
      countDownTime: totolTime, // 计算时间
      checkCodeText: '获取验证码',
      downTimeIng: false,
      tencentCaptcha: null, // 验证码防水墙
      formLoading: true,
    };
  },
  computed: {
    btnDisabled() {
      const result = PHONE_REG.test(this.form.phone) && this.form.checkCode;
      return !result;
    },
    codeBtnStatus() {
      return PHONE_REG.test(this.form.phone) && !this.downTimeIng;
    },
    beforeOkta() {
      // 是否为okta登录，且没有完成了okta登录
      return this.loginType === 3 && !this.loginReadyOkta;
    },
    afterOkta() {
      // 是否为okta登录，且已经完成了okta登录
      return this.loginType === 3 && this.loginReadyOkta;
    },
  },
  watch: {},
  mounted() {
    this.initCodeStatus();
    this.loadCaptcha();
    this.loadLoginConfig();
    // this.generateNonce();
  },
  methods: {
    loadLoginConfig() {
      this.$store.dispatch('login/getLoginConfig').then((loginConfig) => {
        console.log('登录页 获取loginConfig', loginConfig);
        this.loginType = loginConfig.login_type;
        this.formLoading = false;
        LoginConfig = loginConfig;
        if (this.loginType === 2) {
          // 企业微信扫码登录
          wwloginConfig.agentid = loginConfig.auth_agent_id;
          wwloginConfig.appid = loginConfig.qiye_corpid;
          console.log(wwloginConfig);
          this.$nextTick(() => {
            this.getLoginQrCode();
          });
        }
        if (this.loginType === 3) {
          // okta认证登录
          this.checkOktaLogin();
        }
      });
    },
    checkOktaLogin() {
      console.log('检查okta登录状态：', query('code') && query('state'));
      this.loginReadyOkta = query('code') && query('state');
      if (query('code') && query('state')) {
        // okta登录完毕，获取登录态
        this.formLoading = true;
        login.setStorageType('cookie');
        login
          .oktaLogin(query('code'), query('state'), lstore.getItem('nonce'))
          .then(({ phone, status }) => {
            this.$message.success('获取手机号成功！');
            this.formLoading = false;
            this.form.phone = phone;
            console.log(status);
          })
          .catch((e) => {
            this.$message.error(e);
            setTimeout(() => {
              this.formLoading = false;
              this.loginReadyOkta = false;
            }, 1000);
          });
      } else if (query('error')) {
        this.$message.error(`okta验证失败，${decodeURIComponent(query('error_description'))}`);
      }
    },
    generateNonce() {
      // 生成用于okta登录认证的nonce
      const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let nonce = '';
      for (let i = 0; i < 32; i++) {
        const randomPoz = Math.floor(Math.random() * charSet.length);
        nonce += charSet.substring(randomPoz, randomPoz + 1);
      }
      return nonce;
    },
    loginByOkta() {
      // 下面的缩进不要整成有空格的
      if (!this.loginReadyOkta) {
        const nonce = this.generateNonce();
        lstore.setItem('nonce', nonce);
        const url = `
${LoginConfig.auth_issuer_url}/v1/authorize?
client_id=${LoginConfig.auth_client_id}
&nonce=${lstore.getItem('nonce')}
&redirect_uri=${encodeURIComponent(`${document.location.origin}/saas/login.html`)}
&response_mode=query
&response_type=code
&scope=openid+profile+email
&state=${this.generateNonce()}`;
        this.g_tourl(url, { href: true });
      }
    },
    getLoginQrCode() {
      try {
        // eslint-disable-next-line no-undef
        new WwLogin({
          ...wwloginConfig,
        });
      } catch (err) {}
    },
    userLogin() {
      if (!this.btnDisabled) {
        login.setStorageType(this.form.autoLogin ? 'cookie' : 'sstore');
        login
          .phoneLogin(this.form.phone, this.form.checkCode)
          .then(() => {
            this.$message.success('登陆成功');
            const redirectUri = query('redirect_uri');
            if (redirectUri) {
              const redirectDomain = getUrlDomain(redirectUri);
              console.log('config.domain', config.domain);
              console.log('redirectDomain', redirectDomain);
              if (config.domain.includes(redirectDomain)) {
                this.g_tourl(redirectUri, { replace: true, href: true });
              } else {
                gotoHome();
              }
            } else {
              gotoHome();
            }
          })
          .catch((err) => {
            this.$message.error(err.bizcode === 4010 ? '验证码错误，请重新输入' : '登陆失败');
          });
      }
    },
    phoneLoginByOkta() {
      if (!this.btnDisabled) {
        login
          .oktaBindPhone(this.form.phone, this.form.checkCode)
          .then(() => {
            this.$message.success('登陆成功');
            const redirectUri = query('redirect_uri');
            if (redirectUri) {
              this.g_tourl(redirectUri, { replace: true, href: true });
            } else {
              gotoHome();
            }
          })
          .catch((err) => {
            this.$message.error(err.bizcode === 4010 ? '验证码错误，请重新输入' : '登陆失败');
          });
      }
    },
    countDown() {
      this.downTimeIng = true;
      this.checkCodeText = `${this.countDownTime}秒后重新发送`;
      setTimeout(() => {
        this.countDownTime -= 1;
        if (this.countDownTime === 0) {
          this.countDownTime = totolTime;
          this.checkCodeText = '重新发送';
          this.downTimeIng = false;
        } else {
          this.countDown();
        }
      }, 1000);
    },
    startCountDown() {
      if (this.downTimeIng) return;
      if (!PHONE_REG.test(this.form.phone)) {
        this.$message('手机号格式不正确');
        return;
      }
      this.countDown();
      try {
        window.localStorage.setItem('myEndTime', Date.now() / 1000 + totolTime);
        window.localStorage.setItem('loginPhone', this.form.phone);
      } catch (e) {}
      const sendSms = (params = {}) => {
        return SendSmsCode({ phone: this.form.phone, sms_product: 1001, ...params }).then((res) => {
          if (res?.error_code === 0) {
            this.$message.success('获取验证码成功');
          } else {
            this.validateError(res, sendSms);
          }
        });
      };
      sendSms().catch((err) => {
        // 兼容原本验证码失败逻辑
        const message =
          err.bizcode === 4013 || err.bizcode === 98
            ? '达到验证上限，请明天再试'
            : '验证码获取失败';
        this.$message.error(message);
      });
    },
    // 初始化状态
    initCodeStatus() {
      try {
        const myEndTime = localStorage.getItem('myEndTime');
        this.form.phone = localStorage.getItem('loginPhone');
        //   已经过了倒计时的时间,可以重新请求验证码
        if (myEndTime > 0 && myEndTime > Date.now() / 1000) {
          this.countDownTime = parseInt(myEndTime - Date.now() / 1000);
          // 继续倒计时
          this.countDown();
        } else {
          localStorage.removeItem('myEndTime');
        }
      } catch (e) {}
    },
    loadCaptcha() {
      if (!window.TencentCaptcha) {
        loadJs({
          url: 'https://ssl.captcha.qq.com/TCaptcha.js',
          onload: () => {
            console.log('load TCaptcha success');
          },
        });
      }
    },
    // 验证码防水墙
    validateError(res, validCb) {
      // 疑似用户
      if (res?.error_code === 99 || res?.error_code === 98) {
        if (!this.tencentCaptcha) {
          this.tencentCaptcha = new window.TencentCaptcha('2061757956', (res) => {
            if (res.ret !== 0) {
              return;
            }
            validCb({ ticket: res.ticket, randStr: res.randstr });
          });
        }
        this.tencentCaptcha.show();
      }
      // 防水墙验证失败
      if (res?.error_code === 100) {
        this.$message.error('验证失败');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.login_bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('https://baike-med-1256891581.file.myqcloud.com/2021031/a1c9fc70-885c-11eb-b125-7f92a53361a2_0.png')
    no-repeat center center rgba(120, 199, 255, 0.18);
  background-size: cover;
  .form_container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 400px;
    height: 535px;
    background: #ffffff;
    border-radius: 8px;
    margin-top: -267.5px;
    margin-left: -200px;
    box-sizing: border-box;
    padding-top: 40px;
    text-align: center;
    .logo_col,
    .system_title {
      text-align: center;
    }
    .logo_col {
      img {
        width: 46px;
        height: 46px;
      }
    }
    .system_title {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.68);
      letter-spacing: 0;
      text-align: center;
      font-weight: bold;
      margin-top: 50px;
    }
    .form_box {
      padding: 40px;
      .checkCode_col {
        display: flex;
        .checkCode_input {
          flex: 1;
          /*::v-deep input::-webkit-outer-spin-button,
          ::v-deep input::-webkit-inner-spin-button {
              -webkit-appearance: none;
          }
          ::v-deep input[type="number"]{
              -moz-appearance: textfield;
          }*/
        }
        .getCode {
          width: 131px;
          margin-left: 10px;
          background: #ffffff;
          border: 1px solid rgba(0, 0, 0, 0.08);
          border-radius: 8px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
          letter-spacing: 0;
          padding: 0;
        }
        .getCode:hover {
          background: rgba(0, 0, 0, 0.04);
          border: 1px solid rgba(0, 0, 0, 0.08);
        }
        .getCode:disabled {
          color: rgba(0, 0, 0, 0.25);
        }
      }
      .auto_login {
        text-align: left;
      }
    }
    .login_btn {
      background: #a0cfff; // 置灰的颜色 border: 3px solid rgba(0,0,0,0.25);
      box-shadow: 0 6px 15px 0 rgba(14, 35, 57, 0.1);
      width: 320px;
      height: 48px;
      cursor: no-drop;
      border-radius: 8px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      border: none;
      &.active {
        width: 320px;
        height: 48px;
        cursor: pointer;
        background: #42a0ff;
        box-shadow: 0 6px 15px 0 rgba(14, 35, 57, 0.1);
        border-radius: 8px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        &:hover {
          color: #ffffff;
          box-shadow: 0 6px 15px 0 rgba(14, 35, 57, 0.1);
          background: #63b0ff;
        }
      }
    }
    .document_col {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.25);
      letter-spacing: 0;
      margin-top: 30px;
      .and {
        margin: 0 5px;
      }
      span {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.25);
        letter-spacing: 0;
        height: 17px;
        cursor: pointer;
        text-decoration: underline;
        &:hover {
          color: #42a0ff;
        }
      }
    }
    .produced_col {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.25);
      letter-spacing: 0;
      margin-top: 10px;
    }
  }
}
</style>
